<eo-base-form-control
  [label]="getLabel()"
  [help]="getHelp()"
  [errors]="getErrors()"
  [notApplicableLabel]="notApplicableLabel"
  [canBeNotApplicable]="canBeNotApplicable"
  [notApplicable]="notApplicable"
  (onRemove)="onRemoveHandler()"
  (onChange)="onChangeHandler($event)"
  (onBlur)="onBlurHandler($event)"
  (onFocus)="onFocusHandler($event)"
>
  <p-calendar
    styleClass="w-full {{ getDatePickerStyleClass() }}"
    iconDisplay="input"
    [id]="id"
    [tabindex]="getTabIndex()"
    [placeholder]="getPlaceholder()"
    [formControl]="getFormControl()"
    [showClear]="getShowClear()"
    [showIcon]="getShowIcon()"
    [showButtonBar]="getShowButtonBar()"
    [appendTo]="getAppendTo()"
    [showOnFocus]="getShowOnFocus()"
    [dateFormat]="getDateFormat()"
    [minDate]="getMinDate()"
    [maxDate]="getMaxDate()"
    [showTime]="showTime"
    [timeOnly]="timeOnly"
    (onRemove)="onRemoveHandler()"
    (onSelect)="onSelect($event)"
    (onFocus)="focus.emit($event)"
    (onBlur)="blur.emit($event)"
  >
    <ng-template pTemplate="clearicon">
      <i class="pi pi-times pointer-events-none"></i>
    </ng-template>
    <ng-template pTemplate="inputicon">
      <i
        *ngIf="handleIconChange() | async"
        class="pi pi-{{ getIcon() }} pointer-events-none"
      ></i>
    </ng-template>
    <ng-content />
  </p-calendar>
</eo-base-form-control>
